let webSock = null;
let webSocketList = [];
let webSocketMethodList = [];
let id = 0;

// 成功接收主题
let messageCallback = null;

// 失败接收主题
let errorCallback = null;

// 给后台推送数据
let params = null;

// 初始化
function initWebSocket(url,myid) {
  if (typeof WebSocket === "undefined") {
    window.vm.$Message.error("您的浏览器不支持WebSocket，无法获取数据");
    return false;
  }
  // ws请求完整地址
  console.log("webSocket", url);
  const requestWebSocketUrl = process.env.VUE_APP_BASE_WS_API + url
  // webSock = new WebSocket(requestWebSocketUrl);
  webSocketList[myid] = new WebSocket(requestWebSocketUrl);
  webSocketList[myid].onmessage = function (e) {
    try {
      webSocketMethodList[myid].messageCallback(JSON.parse(e.data));
    } catch (error) {

      webSocketMethodList[myid].messageCallback(e.data);
    }
  };
  // webSocketList[id].onopen = function () {
  //   webSocketMethodList[id].websocketOpen();
  // };
  webSocketList[myid].onerror = function () {
    window.vm.$Message.error("ws连接异常，请稍候重试");
    webSocketMethodList[myid].errorCallback();
  };
  webSocketList[myid].onclose = function (e) {
    webSocketClose(e);
  };
  // webSock.onmessage = function (e) {
  //   webSocketOnMessage(e);
  // };
  // webSock.onopen = function () {
  //   websocketOpen();
  // };
  // webSock.onerror = function () {
  //   window.vm.$Message.error("ws连接异常，请稍候重试");
  //   errorCallback();
  // };
  // webSock.onclose = function (e) {
  //   webSocketClose(e);
  // };
}
// 建立ws连接
function websocketOpen(e) {
  console.log("ws连接成功");
  websocketSend(params);
}
/**
 * 发起websocket连接
 * @param {Object} params 需要向后台传递的参数数据
 */
function websocketSend(params) {
  // 添加状态判断，当为OPEN时，发送消息
  if (webSocketList[id].readyState === webSocketList[id].OPEN) {
    // 发给后端的数据需要字符串化
    webSocketList[id].send(JSON.stringify(params));
  }
  // 报错之后调用失败的回调
  if (webSocketList[id].readyState === webSocketList[id].CLOSED) {
    errorCallback();
  }

  // // 添加状态判断，当为OPEN时，发送消息
  // if (webSock.readyState === webSock.OPEN) {
  //   // 发给后端的数据需要字符串化
  //   webSock.send(JSON.stringify(params));
  // }
  // // 报错之后调用失败的回调
  // if (webSock.readyState === webSock.CLOSED) {
  //   errorCallback();
  // }
}
// 成功返回数据
function webSocketOnMessage(e) {
  try {

    messageCallback(JSON.parse(e.data));
  } catch (error) {

    messageCallback(e.data);
  }
}

// 关闭ws连接
function webSocketClose(e) {
  console.log("关闭情况", e);
  // e.code === 100 正常关闭  else  非正常关闭
  if (e && e.code !== 1000) {
    // 关闭socket失败处理
  }
}

/**
 * 发起websocket请求函数
 * @param {number} myid websocket的id
 * @param {string} url 地址
 * @param {Object} params 参数
 * @param {function} successCallback 成功的回调函数
 * @param {function} errCallback ws连接错误的回调函数
 */
export const sendWebsocket = (myid, url, params, successCallback, errCallback) => {
  id = myid;
  webSocketMethodList[myid] = {};
  webSocketMethodList[myid].messageCallback = successCallback;
  webSocketMethodList[myid].errorCallback = errCallback;
  webSocketMethodList[myid].params = params;
  initWebSocket(url,myid);
  console.log("进入",myid, successCallback,webSocketMethodList[myid].messageCallback);
};

/**
 * 关闭websocket函数
 */
export const closeWebsocket = (myid) => {
  console.log("关闭2",webSocketMethodList[2]?.messageCallback);
  console.log("关闭3",webSocketMethodList[3]?.messageCallback);
  console.log("关闭myid",webSocketMethodList[myid]?.messageCallback);
  id = myid;
  if (webSocketList[myid]) {
    console.log("关闭详情", webSocketList[myid]);
    webSocketList[myid].onclose(); // 关闭websocket
    webSocketList[myid].close();
  }
};